import { reducer as reduxFormReducer } from "redux-form";
import { combineReducers } from "redux";

import { sidebarReducer, themeReducer } from "./containers/Layout/reducers";
import { alert as notificationReducer } from "./containers/Notifications/reducers/alert.reducer";

import {
  viewuser,
  postuser,
  getusers,
  toggleuser,
  editRole,
  getuserrole,
} from "./containers/Users/reducers";

import {
  getAllCardRequests,
  getCardRequest,
  getCardStatus,
  createCard,
  retryCardRequestReducer,
  sendSuccessCardsReducer,
} from "./containers/CardRequests/reducers";

import {
  getAllIssuerConfig,
  getIssuerConfig,
  createIssuerConfig,
  deleteIssuerConfig,
} from "./containers/IssuerConfiguration/reducers";

import {
  getAllScpIssuerConfig,
  getAllScpEmvProfileCode,
  getAllPersoFormatCode,
} from "./containers/SCPConfigurations/reducers";

import {
  getAllIssuerDomainMapping,
  getIssuerDomainMapping,
  createIssuerDomainMapping,
} from "./containers/MapIssuersDomains/reducers";

import { domains } from "./containers/Domains/reducers";
import { scpIssuers, postCardIssuers } from "./containers/Issuers/reducers";
import { permissions, currentUser } from "./containers/CurrentUser/reducers";
import { roles } from "./containers/Roles/reducers";

import { cardProgramCount } from "./containers/Dashboard/reducers";

import { getCustomers, getCustomer } from "./containers/Customers/reducers";
import {
  getCardRecords,
  getCardRecord,
  pinReissue,
  blockCard,
  unblockCard,
} from "./containers/CardRecords/reducers";
import {
  downloadCardStatement,
  pdfDownloadCardStatement,
  transactionReport,
} from "./containers/TransactionReport/reducers";
import { cardStatement } from "./containers/CardStatements/reducers";
import {
  searchCards,
  getCardProgramsFromIssuer,
} from "./containers/CardSearch/reducers";

import {
  getActivityUsers,
  auditBy,
  activityLog,
  downloadActivityLog,
  pdfDownloadActivityLog,
} from "./containers/AuditTrail/reducers";

export default combineReducers({
  form: reduxFormReducer,
  theme: themeReducer,
  sidebar: sidebarReducer,
  notification: notificationReducer,

  viewuser,
  getusers,
  postuser,
  toggleuser,
  domains,
  permissions,
  currentUser,
  getuserrole,
  editRole,
  roles,

  getAllCardRequests,
  getCardRequest,
  getCardStatus,
  createCard,
  retryCardRequestReducer,
  sendSuccessCardsReducer,

  getAllIssuerConfig,
  getIssuerConfig,
  createIssuerConfig,
  deleteIssuerConfig,

  getAllScpIssuerConfig,
  getAllScpEmvProfileCode,
  getAllPersoFormatCode,

  getAllIssuerDomainMapping,
  getIssuerDomainMapping,
  createIssuerDomainMapping,

  scpIssuers,
  postCardIssuers,

  getCustomers,
  getCustomer,

  getCardRecords,
  getCardRecord,

  cardStatement,
  downloadCardStatement,
  pdfDownloadCardStatement,
  transactionReport,

  searchCards,
  getCardProgramsFromIssuer,

  pinReissue,
  blockCard,
  unblockCard,

  cardProgramCount,

  getActivityUsers,
  auditBy,
  activityLog,
  pdfDownloadActivityLog,
  downloadActivityLog,
});
